import { NotificationService } from '@optsolservices/ngx-notification';
import { OiGroupProcessDialogComponent } from './../../../shared/oi-group-process-dialog/oi-group-process-dialog.component';
import { BaseService } from './../../../core/services/base.service';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OiGroupDialogData } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';

@Component({
  selector: 'app-pos-tfg-account-details',
  templateUrl: './pos-tfg-account-details.component.html',
  styleUrls: ['./pos-tfg-account-details.component.scss']
})
export class PosTfgAccountDetailsComponent implements OnInit {
  form: FormGroup;
  tfgAccountDetails: any = null;
  tfgRewardsDetails: any = null;
  alreadyLinked: boolean = false;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<PosTfgAccountDetailsComponent>,
    private baseService: BaseService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.form = fb.group({
      storeId: [null],
      tfgCardNumber: [null, Validators.compose([Validators.required, Validators.minLength(19), Validators.maxLength(19), Validators.pattern('[0-9]+')])],
      trackTwo: [null]
    });
  }

  ngOnInit() {
    this.form.controls['storeId'].setValue(this.data.storeId);
    if (this.data.tfgRequestId) {
      this.form.controls['tfgCardNumber'].disable();
      this.baseService.executeCommand<any>('portal_tfg_request_card_details', {
        requestId: this.data.tfgRequestId
      }).subscribe(response => {
        if (response.responseCode === 0) {
          this.form.controls['tfgCardNumber'].setValue(response.data.tfgCardNumber);
          this.form.controls['tfgCardNumber'].updateValueAndValidity();
          this.form.controls['trackTwo'].setValue(response.data.trackTwo);

          if (response.data.tfgCardNumber) {
            this.alreadyLinked = true;
            this.tfgRewardsDetails = response.data.tfgRewardsDetails;
          }
          this.validate();
        }
      });
    }
  }
  checkForTfgCardScan(event, value: string) {
    if (value) {
      const regex = new RegExp(`^;[0-9]{19}=[0-9]{17}\\?$`);
      if (regex.test(value)) {
        const cardPieces = value.split('=');
        const cardNumber = cardPieces[0].replace(';', '');
        this.form.controls['tfgCardNumber'].setValue(cardNumber);
        this.form.controls['trackTwo'].setValue(value);
        this.validate();
      } else {
        this.form.controls['trackTwo'].setValue(null);
      }

    }
  }

  validate() {
    this.tfgAccountDetails = null;
    if (!this.alreadyLinked) {
      this.tfgRewardsDetails = null;
    }

    const dialogData: OiGroupDialogData = {
      title: 'Validating TFG Credit Card',
      function: 'portal_oi_group_payment_validate_tfg_card',
      postBody: Object.assign(this.form.getRawValue(), { portalProcess: this.data.tfgRequestId ? 'LINK' : 'VIEW' })
    };

    const ref = this.dialog.open(OiGroupProcessDialogComponent, {
      data: dialogData,
      width: '450px'
    });

    ref.afterClosed().subscribe(oiResult => {
      if (oiResult.responseCode === 0 && oiResult.data && oiResult.data.groupProcessedSuccessfully === true) {
        this.baseService.executeCommand<any>('portal_pos_payment_tfg_validation_details', oiResult.data).subscribe(detailResponse => {
          if (detailResponse.responseCode === 0) {
            this.tfgAccountDetails = detailResponse.data;

            if (this.alreadyLinked === false) {
              // We're not going live with this for now
              // this.checkTfgForLoyalty();
            }
          }
        });
      }
    });
  }

  checkTfgForLoyalty() {

    const dialogData: OiGroupDialogData = {
      title: 'Validating TFG Rewards',
      function: 'portal_oi_group_rewards_validate_profile',
      postBody: {
        storeId: this.form.getRawValue().storeId,
        identifierType: 'TFG-CREDIT-CARD',
        identifierValue: this.form.getRawValue().tfgCardNumber
      },
    };

    const ref = this.dialog.open(OiGroupProcessDialogComponent, {
      data: dialogData,
      width: '450px',
    });

    ref.afterClosed().subscribe((oiResult) => {
      if (
        oiResult.responseCode === 0 &&
        oiResult.data &&
        oiResult.data.groupProcessedSuccessfully === true
      ) {
        this.baseService
          .executeCommand<any>(
            'portal_tfg_rewards_get_customer_profile_by_oi_group_id',
            oiResult.data
          )
          .subscribe((detailResponse) => {
            if (detailResponse.responseCode === 0) {
              if (detailResponse.data.IsSuccess === true) {
                this.tfgRewardsDetails = detailResponse.data;
              } else {
                this.notificationService.error(`Loyalty: ${detailResponse.data.ErrorDescription}`);
              }
            }
          });
      } else {
        this.dialogRef.close(true);
      }
    });

  }

  save() {
    this.baseService.executeCommand<any>('portal_sales_order_header_link_tfg_account', {
      salesOrderHeaderId: this.data.salesOrderHeaderId,
      requestId: this.tfgAccountDetails.requestId,
      rewardsRequestId: this.tfgRewardsDetails ? this.tfgRewardsDetails.requestId : null
    }).subscribe(response => {
      if (response.responseCode === 0) {
        this.dialogRef.close(true);

      }
    });
  }

}
